import { Wrapper } from './learn.styles';
import styled from 'styled-components';
import TopBar from '../home/components/TopBar';
import Chat from './components/Chat';
import Scene from './components/Scene';
import Words from './components/Words';
import Flashcards from './components/Flashcards';
import ImageMode from './components/ImageMode';
import Loading from '@/common/components/Loading';
import ChatDesktop from './desktop/ChatDesktop';
import ImageModeDesktop from './desktop/ImageModeDesktop';
import SceneDesktop from './desktop/SceneDesktop';
import WordsDesktop from './desktop/WordsDesktop';
import FlashcardsDesktop from './desktop/FlashcardsDesktop';
import CallModeDesktop from './desktop/CallModeDesktop';
import CallMode from './components/CallMode';
import WordTrainerDesktop from './desktop/WordTrainerDesktop';
import WordTrainer from './components/WordTrainer';
import useLearn from './hooks/useLearn';

const CurrentWrapper = styled(Wrapper)`
	@media (min-width: 600px) {
		padding-top: 30px;
		padding-bottom: 30px;
		overflow-y: auto;
	}

	@media (max-width: 600px) {
		overflow-x: hidden;
		overflow-y: auto;
	}
`;

const Mobile = styled.div`
	@media (min-width: 800px) {
		display: none;
	}
`;

const Desktop = styled.div`
	@media (max-width: 800px) {
		display: none;
	}
`;

const Learn = () => {
	const {
		learnData,
		favoriteArr,
		scenesToDisplay,
		scenesType,
		handleAddToFavorite,
		isLoading,
	} = useLearn();

	return (
		<>
			{isLoading && <Loading />}
			<CurrentWrapper>
				<Mobile>
					<TopBar
						numberTwo={learnData?.stats?.wordsNumber}
						numberOne={learnData?.streak}
					/>
					<Chat />
					<Flashcards
						data={learnData?.flashcards}
						handleAddToFavorite={handleAddToFavorite}
						liked={favoriteArr}
					/>
					<WordTrainer />
					<CallMode />
					<Scene
						data={scenesToDisplay}
						handleAddToFavorite={handleAddToFavorite}
						liked={favoriteArr}
						type={scenesType}
					/>
					<Words
						data={learnData?.words}
						handleAddToFavorite={handleAddToFavorite}
						liked={favoriteArr}
					/>
					<ImageMode />
				</Mobile>
				<Desktop>
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							gap: '32px',
						}}
					>
						<ChatDesktop />
						<ImageModeDesktop />
					</div>
					<div
						style={{
							display: 'flex',
							justifyContent: 'left',
							alignItems: 'center',
							gap: '32px',
						}}
					>
						<CallModeDesktop />
						<WordTrainerDesktop />
					</div>
					<FlashcardsDesktop
						data={learnData?.flashcards}
						handleAddToFavorite={handleAddToFavorite}
						liked={favoriteArr}
					/>
					<SceneDesktop
						data={scenesToDisplay}
						handleAddToFavorite={handleAddToFavorite}
						liked={favoriteArr}
						type={scenesType}
					/>
					<WordsDesktop
						data={learnData?.words}
						handleAddToFavorite={handleAddToFavorite}
						liked={favoriteArr}
					/>
				</Desktop>
			</CurrentWrapper>
		</>
	);
};

export default Learn;
